import { Box, Text, Flex, useDisclosure } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import SearchInput from "@root/components/common/SearchInput";
import { DataTable } from "@root/components";
import { useEffect, useState } from "react";
import { RegisterSubscriberButton } from "./style";
import { AddSubscriberModal } from "@root/components/kpec-admin/subscriber-management/addsubscriberModal";
import { MemberTableColumns } from "@root/components/kpec-admin/subscriber-management/membercolumns";
import SectionHeader from "@root/components/kpec-admin/subscriber-management/sectionheader";
import { PlusIcon } from "@root/assets/admin/icons/plusicon";
import { useLocation, useParams } from "react-router-dom";
import { useSubscriberContext } from "@root/context/use-subscriber-context";
import { RECORDS_PER_PAGE } from "@root/constants";

const SubscriberMembers = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation("common");
  const { userid } = useParams<{ userid: string }>();
  const [page, setPage] = useState(1);
  const [members, setMembers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const {
    pageNo,
    setPageNo,
    pageCount,
    fetchSubscriberMembers,
    subscriberMembers,
  } = useSubscriberContext();
  const pageSize = RECORDS_PER_PAGE;
  const location = useLocation();
  const subscriberName = location.state?.companyName;
  console.log("pageNo", pageCount);
  const payload = {
    offset: (pageNo - 1) * pageSize,
    limit: pageSize,
    subscriberId: `${userid}`,
  };

  useEffect(() => {
    const newPayload = {
      offset: (pageNo - 1) * pageSize,
      limit: pageSize,
      subscriberId: `${userid}`,
      search: searchTerm || "",
    };
    setLoading(true);
    fetchSubscriberMembers(newPayload).finally(() => setLoading(false));
  }, [userid, pageNo, searchTerm]); // Include searchTerm in dependencies

  function handlePageChange(newPage: number) {
    setPageNo(newPage);
    const payload = {
      offset: (newPage - 1) * pageSize,
      limit: pageSize,
      subscriberId: `${userid}`,
      search: searchTerm || "",
    };
    fetchSubscriberMembers(payload);
  }

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchTerm = e.target.value;
    setSearchTerm(newSearchTerm);
    setPageNo(1);
    const payload = {
      offset: 0,
      limit: pageSize,
      subscriberId: `${userid}`,
      search: newSearchTerm || "",
    };
    fetchSubscriberMembers(payload);
  };
  return (
    <Flex direction="column" height="100%" bg="white" padding={"24px 16px"}>
      <Box display="flex" justifyContent="space-between" mt="4">
        <Box>
          <Text fontWeight={600} color="#2F2F34" fontSize="24px" mb="10px">
            {t("subscriberManagement.title")}
          </Text>
          <Text color="#798692" maxWidth="600px">
            {t("subscriberManagement.description")}
          </Text>
        </Box>
        <RegisterSubscriberButton onClick={onOpen}>
          <PlusIcon mr="10px" />
          {t("subscriberManagement.registerNewSubscriber")}
        </RegisterSubscriberButton>
        <AddSubscriberModal isOpen={isOpen} onClose={onClose} />
      </Box>

      <Flex justifyContent="space-between" my={10}>
        <SearchInput
          placeholder={t("subscriberManagement.searchJournalist")}
          width="500px"
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </Flex>
      <Box my={10}>
        {/* 🔹 Breadcrumb */}
        <Text mt={4} fontSize="16px" fontWeight="500" color="#2F2F34">
          {subscriberName}{" "}
          <span style={{ color: "#1819B4" }}>{`> ${t(
            "subscriberManagement.members"
          )}`}</span>
        </Text>
      </Box>

      {loading ? (
        <Text>{t("subscriberManagement.loading")}</Text>
      ) : subscriberMembers?.length === 0 ? (
        <Text>
          {t("subscriberManagement.noMembersFoundForUser")}
          {userid}
        </Text>
      ) : (
        <DataTable
          columns={MemberTableColumns(t)}
          data={subscriberMembers}
          showPagination={true}
          page={pageNo}
          pageCount={pageCount}
          pageSize={pageSize}
          handlePageChange={handlePageChange}
          theadBg="#dad5f5"
          rowHoverBg="gray.50"
        />
      )}
    </Flex>
  );
};

export default SubscriberMembers;
